import styled from "styled-components"
export const PageTitle = styled.h2`
  font-size: 1rem;
  padding: 1rem 0;
`
